import "core-js/modules/es.object.seal.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Vue from 'vue';
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'; // import { IToolbarConfig, createToolbar } from '@wangeditor/editor'
// const toolbarConfig = {
//   /* 工具栏配置 */
//   excludeKeys: ['fullScreen']
// }

export default Vue.extend({
  components: {
    Editor: Editor,
    Toolbar: Toolbar
  },
  data: function data() {
    return {
      editor: null,
      html: '',
      toolbarConfig: {
        excludeKeys: ['fullScreen']
      },
      editorConfig: {
        placeholder: ''
      },
      mode: 'simple' //  'simple' or 'default'

    };
  },
  methods: {
    onCreated: function onCreated(editor) {
      this.editor = Object.seal(editor); // 一定要用 Object.seal() ，否则会报错
    },
    onChange: function onChange(editor) {
      console.log('onChange', editor.children);
    }
  },
  mounted: function mounted() {
    // 模拟 ajax 请求，异步渲染编辑器
    // setTimeout(() => {
    //   this.html = ''
    // }, 1500)
    // this.editor.setHtml('')
    console.log(this.editor);
  },
  beforeDestroy: function beforeDestroy() {
    var editor = this.editor;
    if (editor == null) return;
    editor.destroy(); // 组件销毁时，及时销毁编辑器
  }
});